var YouLi = YouLi ? YouLi : {};
YouLi.Account = YouLi.Account ? YouLi.Account : {};
YouLi.Account.Register = YouLi.Account.Register ? YouLi.Account.Register : {};

(function (YouLi) {
    (function (Account) {
        (function (Register) {
            window.AccountRegisterSubmit = function (token) {
                if (token)
                    $('#RecaptchaToken').val(token);

                document.getElementById('RegisterForm').submit();
            };

            YouLi.Account.Register.ToggleMQLFields = function () {
                if ($("#Persona").val().toLowerCase() === "business") {
                    $("#MQLFields").show();
                }
                else {
                    $("#MQLFields").hide();
                }
            };

            YouLi.Account.Register.TogglePlannerFields = function () {
                if ($("#Persona").val().toLowerCase() === "business"
                    || $("#Persona").val().toLowerCase() === "individual") {
                    $("#PlannerFields").show();
                }
                else {
                    $("#PlannerFields").hide();
                }
            };

            YouLi.Account.Register.UpdatePersonaDescription = function () {
                $(".persona-description-text").hide();

                if ($("#Persona").val()) {
                    $("#Persona" + $("#Persona").val()).show();
                }
            };

            YouLi.Account.Register.TogglePasswordShow = function (clickedElement) {
                var inputElement = clickedElement.closest(".form-group").find(".password-field");
                if (inputElement.attr("type") === "password") {
                    inputElement.attr("type", "text");
                } else {
                    inputElement.attr("type", "password");
                }
            };

            $(function () {

                $("#Persona").on("change", function () {
                    YouLi.Account.Register.ToggleMQLFields();
                    YouLi.Account.Register.TogglePlannerFields();
                    YouLi.Account.Register.UpdatePersonaDescription();
                });
                YouLi.Account.Register.ToggleMQLFields();
                YouLi.Account.Register.TogglePlannerFields();
                YouLi.Account.Register.UpdatePersonaDescription();

                $("#Email").focus();

                $(".password-show-link").on("click", function() {
                    YouLi.Account.Register.TogglePasswordShow($(this))
                });

                $(document).on("focus", "#Password", function () {
                    $("#PasswordHelperText").show();
                })

                $(document).on("blur", "#Password", function () {
                    $("#PasswordHelperText").hide();
                });

                $('#RegisterForm').on('submit', function (e) {
                    e.preventDefault();

                    document.getElementById('Password').type = "password"; // reset password type before submitting

                    var form = $(this);

                    if (form.valid()) {
                        var $formSubmitBtn = form.find('button[type="submit"]');
                        YouLi.Common.UI.ShowInputLoading($formSubmitBtn);
                        YouLi.Common.UI.ShowLoading();

                        var includeRecaptcha = $('#IncludeGoogleRecaptchaForAccountRegister').val();

                        if (includeRecaptcha && includeRecaptcha.toLowerCase() === "true") {
                            grecaptcha.ready(function () {
                                grecaptcha.execute("6LelFRkrAAAAACIfEO5pWIRIltUbxfbnBo9LtGQ1", { action: "AccountRegistration" })
                                    .then(function (token) {
                                        window.AccountRegisterSubmit(token);
                                    });
                            });
                        }
                        else {
                            window.AccountRegisterSubmit("");
                        }
                    }

                    return false;
                });
            });
        
        }(YouLi.Account.Register ? YouLi.Account.Register : {}));
    }(YouLi.Account ? YouLi.Account : {}));
}(YouLi ? YouLi : {}));